export const floodFillInterval = 100;
export const maxLineThickness = 50;
export const minLineThickness = 1;
export const lineThicknessRange = maxLineThickness - minLineThickness;
export const thicknessIncrement = 0.5;
export const minSmoothingFactor = 0.87;
export const initialSmoothingFactor = 0.85;
export const weightSpread = 10;
export const initialThickness = 2;
